import { render } from "./Webhooks.vue?vue&type=template&id=20e3a742&scoped=true"
import script from "./Webhooks.vue?vue&type=script&lang=js"
export * from "./Webhooks.vue?vue&type=script&lang=js"

import "./Webhooks.vue?vue&type=style&index=0&id=20e3a742&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e3a742"]])

export default __exports__